const ADMIN_TENANT_STORAGE_KEY = "fmc.adminTenantId";

export function selectedAdminTenant(): string | null {
  return window.sessionStorage.getItem(ADMIN_TENANT_STORAGE_KEY);
}

export function selectAdminTenant(tenantId: string): void {
  window.sessionStorage.setItem(ADMIN_TENANT_STORAGE_KEY, tenantId);
}

export function clearAdminTenant(): void {
  window.sessionStorage.removeItem(ADMIN_TENANT_STORAGE_KEY);
}

export function withTenantHeader(headers?: HeadersInit): Headers {
  const result = new Headers(headers);
  const tenantId = selectedAdminTenant();
  if (tenantId) result.set("X-FMC-Tenant", tenantId);
  return result;
}
